// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: string;
};

export type SingleSignOnUserDto = {
  accountId: string;
  email: string;
};

export const Action = {
  MANAGE: 'MANAGE',
  CREATE: 'CREATE',
  READ: 'READ',
  READ_ALL: 'READ_ALL',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
} as const;

export type Action = (typeof Action)[keyof typeof Action];

export const Subject = {
  All: 'All',
  User: 'User',
  AdminLevel: 'AdminLevel',
  AdminLevelUser: 'AdminLevelUser',
  Report: 'Report',
  ReportAdminLevel: 'ReportAdminLevel',
  ReportCategory: 'ReportCategory',
  ReportComment: 'ReportComment',
  ReportForwarding: 'ReportForwarding',
  ReportImage: 'ReportImage',
  ReportPublication: 'ReportPublication',
  ReportStatus: 'ReportStatus',
  ReportUser: 'ReportUser',
  BicycleNetworkSegment: 'BicycleNetworkSegment',
  RouteSign: 'RouteSign',
  SystemNotification: 'SystemNotification',
} as const;

export type Subject = (typeof Subject)[keyof typeof Subject];

export type CaslEnumDto = {
  action: Action;
  subject: Subject;
};

export type CaslRulesDto = {
  rules: Array<
    Array<
      | Action
      | Subject
      | string
      | number
      | {
          [key: string]: unknown;
        }
    >
  >;
};

export type CreateUserDto = {
  firstName: string;
  lastName: string;
  adminLevelIds: Array<string>;
};

export const UserStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  REGISTERED: 'REGISTERED',
} as const;

export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];

export const UserRole = { ADMIN: 'ADMIN', USER: 'USER' } as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const UserNotificationInterval = {
  IMMEDIATE: 'IMMEDIATE',
  DAILY: 'DAILY',
  WEEKDAYS: 'WEEKDAYS',
  WEEKLY: 'WEEKLY',
  NEVER: 'NEVER',
} as const;

export type UserNotificationInterval = (typeof UserNotificationInterval)[keyof typeof UserNotificationInterval];

export const ReportMainCategory = {
  ROUTE_SIGNAGE: 'ROUTE_SIGNAGE',
  SIGNAGE: 'SIGNAGE',
  CONSTRUCTION_DEFECTS: 'CONSTRUCTION_DEFECTS',
  TRAFFIC_ROUTING: 'TRAFFIC_ROUTING',
  HAZARDS_AND_SAFETY: 'HAZARDS_AND_SAFETY',
  MARKING_AND_LIGHTING: 'MARKING_AND_LIGHTING',
  TRAFFIC_LIGHTS: 'TRAFFIC_LIGHTS',
  MAINTENANCE: 'MAINTENANCE',
  PARKING_AND_SERVICE: 'PARKING_AND_SERVICE',
  LIKE: 'LIKE',
  REQUESTS_AND_SUGGESTIONS: 'REQUESTS_AND_SUGGESTIONS',
  EXTERNAL: 'EXTERNAL',
} as const;

export type ReportMainCategory = (typeof ReportMainCategory)[keyof typeof ReportMainCategory];

export const AdminLevelUserRole = {
  MANAGER: 'MANAGER',
  EDITOR: 'EDITOR',
  VIEWER: 'VIEWER',
} as const;

export type AdminLevelUserRole = (typeof AdminLevelUserRole)[keyof typeof AdminLevelUserRole];

export const AdminLevelUserStatus = { ACTIVE: 'ACTIVE', INACTIVE: 'INACTIVE' } as const;

export type AdminLevelUserStatus = (typeof AdminLevelUserStatus)[keyof typeof AdminLevelUserStatus];

export const AdminLevelType = {
  STATE: 'STATE',
  GOVERNMENT_DISTRICT: 'GOVERNMENT_DISTRICT',
  COUNTY: 'COUNTY',
  CITY_COUNTY: 'CITY_COUNTY',
  MUNICIPALITY: 'MUNICIPALITY',
} as const;

export type AdminLevelType = (typeof AdminLevelType)[keyof typeof AdminLevelType];

export const ExternalReportPlatformType = {
  NONE: 'NONE',
  LINK: 'LINK',
  OPEN311: 'OPEN311',
} as const;

export type ExternalReportPlatformType = (typeof ExternalReportPlatformType)[keyof typeof ExternalReportPlatformType];

export type MultiPolygonDto = {
  type: 'MultiPolygon';
  coordinates: Array<Array<Array<Array<number>>>>;
};

export type ExternalReportCategory = {
  name: string;
  code: string;
};

export const ReportPublicationType = {
  PUBLIC: 'PUBLIC',
  REDACTED: 'REDACTED',
  HIDDEN: 'HIDDEN',
} as const;

export type ReportPublicationType = (typeof ReportPublicationType)[keyof typeof ReportPublicationType];

export const ReportStatusType = {
  NEW: 'NEW',
  WORK_IN_PROGRESS: 'WORK_IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  NOT_REALIZABLE: 'NOT_REALIZABLE',
  EXTERNAL: 'EXTERNAL',
  ARCHIVED: 'ARCHIVED',
} as const;

export type ReportStatusType = (typeof ReportStatusType)[keyof typeof ReportStatusType];

export type PointDto = {
  type: 'Point';
  coordinates: Array<number>;
};

export type ReportImage = {
  __caslSubjectType__: Subject;
  width: number;
  height: number;
  report?: Report | null;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export const ReportCommentType = {
  PUBLIC: 'PUBLIC',
  INTERNAL: 'INTERNAL',
  DESCRIPTION: 'DESCRIPTION',
} as const;

export type ReportCommentType = (typeof ReportCommentType)[keyof typeof ReportCommentType];

export type ReportComment = {
  __caslSubjectType__: Subject;
  type: ReportCommentType;
  report?: Report;
  createdBy?: User | null;
  text: string;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export const ReportForwardingType = {
  INTERNAL: 'INTERNAL',
  PUBLIC: 'PUBLIC',
  REDACTED: 'REDACTED',
} as const;

export type ReportForwardingType = (typeof ReportForwardingType)[keyof typeof ReportForwardingType];

export type ReportForwarding = {
  __caslSubjectType__: Subject;
  type: ReportForwardingType;
  report?: Report;
  createdBy?: User;
  recipient: string;
  text: string | null;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type ReportPublication = {
  __caslSubjectType__: Subject;
  type: ReportPublicationType;
  report?: Report;
  createdBy?: User | null;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type ReportStatus = {
  __caslSubjectType__: Subject;
  type: ReportStatusType;
  report?: Report;
  createdBy?: User | null;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type ReportUser = {
  __caslSubjectType__: Subject;
  report?: Report;
  createdBy?: User | null;
  user?: User | null;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type User = {
  __caslSubjectType__: Subject;
  status: UserStatus;
  role: UserRole;
  notificationInterval: UserNotificationInterval;
  notificationReportMainCategories: Array<ReportMainCategory>;
  firstName: string;
  lastName: string;
  email: string;
  accountId: string;
  adminLevels?: Array<AdminLevelUser>;
  reports?: Array<Report>;
  reportAdminLevelsCreated?: Array<ReportAdminLevel>;
  reportCommentsCreated?: Array<ReportComment>;
  reportForwardingsCreated?: Array<ReportForwarding>;
  reportPublicationsCreated?: Array<ReportPublication>;
  reportStatusesCreated?: Array<ReportStatus>;
  reportUsers?: Array<ReportUser>;
  reportUsersCreated?: Array<ReportUser>;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type ReportAdminLevel = {
  __caslSubjectType__: Subject;
  reportId: string;
  report?: Report;
  createdBy?: User | null;
  adminLevelId: string;
  adminLevel?: AdminLevel;
  notifyOnComplete: boolean;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type ReportCategory = {
  __caslSubjectType__: Subject;
  mainCategory: ReportMainCategory;
  title: string;
  reports?: Array<Report>;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type ReportPriority = {
  __caslSubjectType__: Subject;
  report?: Report;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type RouteSign = {
  __caslSubjectType__: Subject;
  locationId: string;
  type: string | null;
  municipality: string | null;
  id: number;
  deletedDate: string | null;
  reports?: Array<Report>;
  geometry: PointDto;
  pfosten_nr: string;
  version: number | null;
  wegweiser_typ: string | null;
  pfosten_typ: string | null;
  zustandsbewertung: string | null;
  defizit: string | null;
  pfostenzustand: string | null;
  pfostendefizit: string | null;
  gemeinde: string | null;
  kreis: string | null;
  land: string | null;
  zustaendige_verwaltungseinheit_name: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ServiceStation = {
  __caslSubjectType__: Subject;
  id: number;
  geometry: PointDto;
  deletedDate: string | null;
  adminLevel?: AdminLevel | null;
  name: string;
  gebuehren: boolean;
  oeffnungszeiten: string | null;
  betreiber: string;
  marke: string | null;
  luftpumpe: boolean;
  kettenwerkzeug: boolean;
  werkzeug: boolean;
  fahrradhalterung: boolean;
  beschreibung: string | null;
  zustaendig: string;
  zustaendig_orga_typ: string;
  typ: string;
  status: string;
  radkultur: boolean;
  quell_system: string;
  externe_id: string | null;
  urspruengliche_quelle: string | null;
  photo_url: string | null;
  zuletzt_bearbeitet_am: string | null;
  createdAt: string;
  updatedAt: string;
};

export type Report = {
  __caslSubjectType__: Subject;
  publication: ReportPublicationType;
  status: ReportStatusType;
  routeSignLocationId?: string;
  sequentialId?: string;
  externalId?: string | null;
  geometry: PointDto;
  address: string | null;
  geocoderFeatureId: string | null;
  images?: Array<ReportImage>;
  adminLevel?: AdminLevel;
  adminLevels?: Array<ReportAdminLevel>;
  category?: ReportCategory;
  comments?: Array<ReportComment>;
  forwardings?: Array<ReportForwarding>;
  reportedByName?: string | null;
  reportedByEmail?: string | null;
  priority: number;
  priorities?: Array<ReportPriority>;
  publications?: Array<ReportPublication>;
  routeSign?: RouteSign | null;
  serviceStation?: ServiceStation | null;
  statuses?: Array<ReportStatus>;
  user?: User | null;
  users?: Array<ReportUser>;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type AdminLevel = {
  __caslSubjectType__: Subject;
  type: AdminLevelType;
  /**
   * Amtlicher Regionalschlüssel (ARS)
   */
  regionalCode: string;
  sharedNotificationInterval: UserNotificationInterval;
  externalReportPlatformType: ExternalReportPlatformType;
  id: string;
  wfsId: string;
  name: string;
  geometry?: MultiPolygonDto;
  parent?: AdminLevel;
  managedByParent: boolean;
  children?: Array<AdminLevel>;
  active: boolean;
  sharedEmail?: string | null;
  email?: string | null;
  externalReportPlatformUrl: string | null;
  externalReportEndpointUrl?: string | null;
  externalReportJurisdictionId?: string | null;
  externalReportCategories?: Array<ExternalReportCategory>;
  users?: Array<AdminLevelUser>;
  reports?: Array<Report>;
  reportAdminLevels?: Array<ReportAdminLevel>;
  createdAt: string;
  updatedAt: string;
};

export type AdminLevelUser = {
  __caslSubjectType__: Subject;
  role: AdminLevelUserRole;
  status: AdminLevelUserStatus;
  adminLevelId: string;
  adminLevel?: AdminLevel;
  userId: string;
  user?: User;
  createdAt: string;
  updatedAt: string;
};

export type UpdateUserDto = {
  firstName?: string;
  lastName?: string;
  status?: UserStatus;
  role?: UserRole;
  notificationInterval?: UserNotificationInterval;
  notificationReportMainCategories?: Array<ReportMainCategory>;
  email?: string;
};

export type CreateReportDto = {
  geometry: PointDto;
  geocoderFeatureId?: string;
  routeSignLocationId?: string;
  serviceStationId?: number;
  categoryId: string;
  description?: string;
  imageIds?: Array<string>;
  reportedByName?: string | null;
  reportedByEmail?: string | null;
};

export type UpdateReportDto = {
  geometry?: PointDto;
  geocoderFeatureId?: string;
  routeSignLocationId?: string;
  categoryId?: string;
  imageIds?: Array<string>;
};

export type CreateReportAdminLevelDto = {
  adminLevelId: string;
  notifyOnComplete: boolean;
};

export type CreateReportCommentDto = {
  type: ReportCommentType;
  text: string;
};

export type CreateReportPublicationDto = {
  type: ReportPublicationType;
};

export type CreateReportStatusDto = {
  type: ReportStatusType;
};

export type CreateReportUserDto = {
  userId: string | null;
};

export type CreateReportForwardingDto = {
  type: ReportForwardingType;
  recipient: string;
  text?: string;
  sendCopy: boolean;
};

export type ReportResponsibilityCheckDto = {
  active: boolean;
  managedByParent: boolean;
  externalServiceActive: boolean;
  adminLevelId?: string;
};

export type GeocoderFeaturePropertiesDto = {
  text: string;
};

export type GeocoderFeatureDto = {
  type: 'Feature';
  geometry: PointDto;
  id: string;
  properties: GeocoderFeaturePropertiesDto;
};

export type GeocoderFeatureCollectionDto = {
  type: 'FeatureCollection';
  features: Array<GeocoderFeatureDto>;
};

export type CreateReportCategoryDto = {
  mainCategory: ReportMainCategory;
  title: string;
};

export type UpdateReportCategoryDto = {
  mainCategory?: ReportMainCategory;
  title?: string;
};

export type UpdateAdminLevelDto = {
  sharedNotificationInterval?: UserNotificationInterval;
  active?: boolean;
  managedByParent?: boolean;
  sharedEmail?: string | null;
  email?: string | null;
  externalReportPlatformUrl?: string | null;
  externalReportEndpointUrl?: string | null;
  externalReportJurisdictionId?: string | null;
  activateManagedChildren?: boolean;
};

export type CreateAdminLevelUserDto = {
  role: AdminLevelUserRole;
  status: AdminLevelUserStatus;
};

export type ServiceStationAdminLevel = {
  id: string;
  type: string;
  name: string;
};

export type ServiceStationEquipment = {
  airPump: boolean;
  chainTool: boolean;
  tools: boolean;
  bicycleRack: boolean;
};

export type ServiceStationProperties = {
  id: number;
  name: string;
  adminLevel: ServiceStationAdminLevel;
  fees: boolean;
  openingHours: string | null;
  operator: string;
  equipment: ServiceStationEquipment;
  description: string | null;
  type: string;
  photoUrl: string | null;
  status: string;
};

export const DashboardTimePeriod = {
  THIS_WEEK: 'THIS_WEEK',
  THIS_MONTH: 'THIS_MONTH',
  THIS_YEAR: 'THIS_YEAR',
  LAST_7_DAYS: 'LAST_7_DAYS',
  LAST_30_DAYS: 'LAST_30_DAYS',
  LAST_90_DAYS: 'LAST_90_DAYS',
  LAST_6_MONTHS: 'LAST_6_MONTHS',
  LAST_12_MONTHS: 'LAST_12_MONTHS',
  ALL: 'ALL',
} as const;

export type DashboardTimePeriod = (typeof DashboardTimePeriod)[keyof typeof DashboardTimePeriod];

export type DashboardFilterDto = {
  timePeriod: DashboardTimePeriod;
  adminLevelId?: string;
  categoryIds: Array<string>;
};

export type DashboardReportStatusDto = {
  status: ReportStatusType;
  count: number;
  lastPeriodCount: number;
};

export type DashboardReportLikeDto = {
  count: number;
  lastPeriodCount: number;
};

export type DashboardReportChangeDto = {
  before: Array<ReportStatusType>;
  after: Array<ReportStatusType>;
  id: string;
};

export type DashboardResultDto = {
  reportStatuses: Array<DashboardReportStatusDto>;
  reportLikes: DashboardReportLikeDto;
  reportChanges: Array<DashboardReportChangeDto>;
};

export type CreateExternalReportDto = {
  geometry: PointDto;
  serviceCode: string;
  serviceName: string;
  description?: string;
  address?: string;
  reportedByFirstName?: string;
  reportedByLastName?: string;
  reportedByEmail?: string;
};

export type ExternalReportStatusDto = {
  status?: 'open' | 'closed';
  statusNotes?: string;
};

export type CreateSystemNotificationDto = {
  title: string;
  content: string;
  validFrom: string;
  validTo: string;
};

export type SystemNotification = {
  __caslSubjectType__: Subject;
  title: string;
  content: string;
  validFrom: string;
  validTo: string;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export const SystemNotificationFilter = { ALL: 'ALL', VALID: 'VALID' } as const;

export type SystemNotificationFilter = (typeof SystemNotificationFilter)[keyof typeof SystemNotificationFilter];

export type UpdateSystemNotificationDto = {
  title?: string;
  content?: string;
  validFrom?: string;
  validTo?: string;
};

export type HealthCheckData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/health';
};

export type HealthCheckErrors = {
  /**
   * The Health Check is not successful
   */
  503: {
    status?: string;
    info?: {
      [key: string]: {
        status: string;
        [key: string]: unknown;
      };
    } | null;
    error?: {
      [key: string]: {
        status: string;
        [key: string]: unknown;
      };
    } | null;
    details?: {
      [key: string]: {
        status: string;
        [key: string]: unknown;
      };
    };
  };
};

export type HealthCheckError = HealthCheckErrors[keyof HealthCheckErrors];

export type HealthCheckResponses = {
  /**
   * The Health Check is successful
   */
  200: {
    status?: string;
    info?: {
      [key: string]: {
        status: string;
        [key: string]: unknown;
      };
    } | null;
    error?: {
      [key: string]: {
        status: string;
        [key: string]: unknown;
      };
    } | null;
    details?: {
      [key: string]: {
        status: string;
        [key: string]: unknown;
      };
    };
  };
};

export type HealthCheckResponse = HealthCheckResponses[keyof HealthCheckResponses];

export type AuthenticationLoginData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication/login';
};

export type AuthenticationLoginResponses = {
  200: unknown;
};

export type AuthenticationSamlAssertionConsumerData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication/saml/assertion-consumer';
};

export type AuthenticationSamlAssertionConsumerResponses = {
  201: unknown;
};

export type AuthenticationLogoutData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication/logout';
};

export type AuthenticationLogoutResponses = {
  201: unknown;
};

export type AuthenticationSamlLogoutData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication/saml-logout';
};

export type AuthenticationSamlLogoutResponses = {
  201: unknown;
};

export type AuthenticationSamlSingleLogoutData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication/saml/single-logout';
};

export type AuthenticationSamlSingleLogoutResponses = {
  200: unknown;
};

export type AuthenticationSamlMetadataData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication/saml/metadata';
};

export type AuthenticationSamlMetadataResponses = {
  200: Blob | File;
};

export type AuthenticationSamlMetadataResponse =
  AuthenticationSamlMetadataResponses[keyof AuthenticationSamlMetadataResponses];

export type AuthenticationGetUserData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication';
};

export type AuthenticationGetUserResponses = {
  200: User | SingleSignOnUserDto;
};

export type AuthenticationGetUserResponse = AuthenticationGetUserResponses[keyof AuthenticationGetUserResponses];

export type CaslGetRulesData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/casl';
};

export type CaslGetRulesResponses = {
  200: CaslRulesDto;
};

export type CaslGetRulesResponse = CaslGetRulesResponses[keyof CaslGetRulesResponses];

export type UsersFindAllData = {
  body?: never;
  path?: never;
  query?: {
    search?: string;
    status?: Array<UserStatus>;
    role?: Array<UserRole>;
  };
  url: '/api/users';
};

export type UsersFindAllResponses = {
  200: Array<User>;
};

export type UsersFindAllResponse = UsersFindAllResponses[keyof UsersFindAllResponses];

export type UsersCreateData = {
  body: CreateUserDto;
  path?: never;
  query?: never;
  url: '/api/users';
};

export type UsersCreateResponses = {
  201: User;
};

export type UsersCreateResponse = UsersCreateResponses[keyof UsersCreateResponses];

export type UsersRemoveData = {
  body?: never;
  path: {
    userId: string;
  };
  query?: never;
  url: '/api/users/{userId}';
};

export type UsersRemoveResponses = {
  200: User;
};

export type UsersRemoveResponse = UsersRemoveResponses[keyof UsersRemoveResponses];

export type UsersFindOneData = {
  body?: never;
  path: {
    userId: string;
  };
  query?: never;
  url: '/api/users/{userId}';
};

export type UsersFindOneResponses = {
  200: User;
};

export type UsersFindOneResponse = UsersFindOneResponses[keyof UsersFindOneResponses];

export type UsersUpdateData = {
  body: UpdateUserDto;
  path: {
    userId: string;
  };
  query?: never;
  url: '/api/users/{userId}';
};

export type UsersUpdateResponses = {
  200: User;
};

export type UsersUpdateResponse = UsersUpdateResponses[keyof UsersUpdateResponses];

export type ReportsFindAllData = {
  body?: never;
  path?: never;
  query?: {
    status?: Array<ReportStatusType>;
    mainCategory?: Array<ReportMainCategory>;
    publication?: Array<ReportPublicationType>;
    includeComments?: boolean;
    includeStatuses?: boolean;
    adminLevelId?: string;
    adminLevelIds?: Array<string>;
    search?: string;
    createdAtMin?: string;
    createdAtMax?: string;
    priorityMin?: number;
    priorityMax?: number;
    coordinates?: [number, number];
    distance?: number;
  };
  url: '/api/reports';
};

export type ReportsFindAllResponses = {
  200: Array<Report>;
};

export type ReportsFindAllResponse = ReportsFindAllResponses[keyof ReportsFindAllResponses];

export type ReportsCreateData = {
  body: CreateReportDto;
  path?: never;
  query?: never;
  url: '/api/reports';
};

export type ReportsCreateErrors = {
  /**
   * ThrottlerException: Too Many Requests.
   */
  429: unknown;
};

export type ReportsCreateResponses = {
  /**
   * The report has been successfully created
   */
  201: Report;
};

export type ReportsCreateResponse = ReportsCreateResponses[keyof ReportsCreateResponses];

export type ReportsRemoveData = {
  body?: never;
  path: {
    reportId: string;
  };
  query?: never;
  url: '/api/reports/{reportId}';
};

export type ReportsRemoveResponses = {
  200: Report;
};

export type ReportsRemoveResponse = ReportsRemoveResponses[keyof ReportsRemoveResponses];

export type ReportsFindOneData = {
  body?: never;
  path: {
    reportId: string;
  };
  query?: {
    anonymous?: boolean;
  };
  url: '/api/reports/{reportId}';
};

export type ReportsFindOneResponses = {
  200: Report;
};

export type ReportsFindOneResponse = ReportsFindOneResponses[keyof ReportsFindOneResponses];

export type ReportsUpdateData = {
  body: UpdateReportDto;
  path: {
    reportId: string;
  };
  query?: never;
  url: '/api/reports/{reportId}';
};

export type ReportsUpdateResponses = {
  200: Report;
};

export type ReportsUpdateResponse = ReportsUpdateResponses[keyof ReportsUpdateResponses];

export type ReportsCreateAdminLevelData = {
  body: CreateReportAdminLevelDto;
  path: {
    reportId: string;
  };
  query?: never;
  url: '/api/reports/{reportId}/admin-levels';
};

export type ReportsCreateAdminLevelResponses = {
  201: ReportAdminLevel;
};

export type ReportsCreateAdminLevelResponse = ReportsCreateAdminLevelResponses[keyof ReportsCreateAdminLevelResponses];

export type ReportsCreateCommentData = {
  body: CreateReportCommentDto;
  path: {
    reportId: string;
  };
  query?: never;
  url: '/api/reports/{reportId}/comments';
};

export type ReportsCreateCommentResponses = {
  201: ReportComment;
};

export type ReportsCreateCommentResponse = ReportsCreateCommentResponses[keyof ReportsCreateCommentResponses];

export type ReportsCreatePriorityData = {
  body?: never;
  path: {
    reportId: string;
  };
  query?: never;
  url: '/api/reports/{reportId}/priority';
};

export type ReportsCreatePriorityErrors = {
  /**
   * ThrottlerException: Too Many Requests.
   */
  429: unknown;
};

export type ReportsCreatePriorityResponses = {
  /**
   * The report priority has been successfully created.
   */
  201: ReportPriority;
};

export type ReportsCreatePriorityResponse = ReportsCreatePriorityResponses[keyof ReportsCreatePriorityResponses];

export type ReportsCreatePublicationData = {
  body: CreateReportPublicationDto;
  path: {
    reportId: string;
  };
  query?: never;
  url: '/api/reports/{reportId}/publications';
};

export type ReportsCreatePublicationResponses = {
  201: ReportPublication;
};

export type ReportsCreatePublicationResponse =
  ReportsCreatePublicationResponses[keyof ReportsCreatePublicationResponses];

export type ReportsCreateStatusData = {
  body: CreateReportStatusDto;
  path: {
    reportId: string;
  };
  query?: never;
  url: '/api/reports/{reportId}/statuses';
};

export type ReportsCreateStatusResponses = {
  201: ReportStatus;
};

export type ReportsCreateStatusResponse = ReportsCreateStatusResponses[keyof ReportsCreateStatusResponses];

export type ReportsCreateUserData = {
  body: CreateReportUserDto;
  path: {
    reportId: string;
  };
  query?: never;
  url: '/api/reports/{reportId}/users';
};

export type ReportsCreateUserResponses = {
  201: ReportUser;
};

export type ReportsCreateUserResponse = ReportsCreateUserResponses[keyof ReportsCreateUserResponses];

export type ReportsCreateForwardingData = {
  body: CreateReportForwardingDto;
  path: {
    reportId: string;
  };
  query?: never;
  url: '/api/reports/{reportId}/forwarding';
};

export type ReportsCreateForwardingResponses = {
  201: ReportForwarding;
};

export type ReportsCreateForwardingResponse = ReportsCreateForwardingResponses[keyof ReportsCreateForwardingResponses];

export type ReportsTriggerNotificationsData = {
  body?: never;
  path?: never;
  query: {
    interval: 'DAILY' | 'WEEKDAYS' | 'WEEKLY';
  };
  url: '/api/reports/notifications';
};

export type ReportsTriggerNotificationsResponses = {
  201: unknown;
};

export type ReportResponsibilityGetAdminLevelsData = {
  body?: never;
  path: {
    longitude: number;
    latitude: number;
  };
  query?: never;
  url: '/api/report-responsibility/{longitude}/{latitude}/admin-levels';
};

export type ReportResponsibilityGetAdminLevelsResponses = {
  200: Array<AdminLevel>;
};

export type ReportResponsibilityGetAdminLevelsResponse =
  ReportResponsibilityGetAdminLevelsResponses[keyof ReportResponsibilityGetAdminLevelsResponses];

export type ReportResponsibilityCheckData = {
  body?: never;
  path: {
    longitude: number;
    latitude: number;
  };
  query?: never;
  url: '/api/report-responsibility/{longitude}/{latitude}/check';
};

export type ReportResponsibilityCheckResponses = {
  200: ReportResponsibilityCheckDto;
};

export type ReportResponsibilityCheckResponse =
  ReportResponsibilityCheckResponses[keyof ReportResponsibilityCheckResponses];

export type ReportImagesUploadData = {
  body: {
    file?: Blob | File;
  };
  path?: never;
  query?: never;
  url: '/api/report-images';
};

export type ReportImagesUploadErrors = {
  /**
   * ThrottlerException: Too Many Requests.
   */
  429: unknown;
};

export type ReportImagesUploadResponses = {
  /**
   * The image has been successfully uploaded.
   */
  201: ReportImage;
};

export type ReportImagesUploadResponse = ReportImagesUploadResponses[keyof ReportImagesUploadResponses];

export type ReportImagesFindOneData = {
  body?: never;
  path: {
    reportImageId: string;
  };
  query?: never;
  url: '/api/report-images/{reportImageId}';
};

export type ReportImagesFindOneResponses = {
  default: Blob | File;
};

export type ReportImagesFindOneResponse = ReportImagesFindOneResponses[keyof ReportImagesFindOneResponses];

export type GeocoderGeocodeData = {
  body?: never;
  path: {
    query: string;
  };
  query?: never;
  url: '/api/geocoder/geocode/{query}';
};

export type GeocoderGeocodeResponses = {
  200: GeocoderFeatureCollectionDto;
};

export type GeocoderGeocodeResponse = GeocoderGeocodeResponses[keyof GeocoderGeocodeResponses];

export type GeocoderReverseData = {
  body?: never;
  path: {
    longitude: number;
    latitude: number;
  };
  query?: never;
  url: '/api/geocoder/reverse/{longitude}/{latitude}';
};

export type GeocoderReverseResponses = {
  200: GeocoderFeatureDto;
};

export type GeocoderReverseResponse = GeocoderReverseResponses[keyof GeocoderReverseResponses];

export type ReportCategoriesFindAllData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/report-categories';
};

export type ReportCategoriesFindAllResponses = {
  200: Array<ReportCategory>;
};

export type ReportCategoriesFindAllResponse = ReportCategoriesFindAllResponses[keyof ReportCategoriesFindAllResponses];

export type ReportCategoriesCreateData = {
  body: CreateReportCategoryDto;
  path?: never;
  query?: never;
  url: '/api/report-categories';
};

export type ReportCategoriesCreateResponses = {
  201: ReportCategory;
};

export type ReportCategoriesCreateResponse = ReportCategoriesCreateResponses[keyof ReportCategoriesCreateResponses];

export type ReportCategoriesFindOneData = {
  body?: never;
  path: {
    reportCategoryId: string;
  };
  query?: never;
  url: '/api/report-categories/{reportCategoryId}';
};

export type ReportCategoriesFindOneResponses = {
  200: ReportCategory;
};

export type ReportCategoriesFindOneResponse = ReportCategoriesFindOneResponses[keyof ReportCategoriesFindOneResponses];

export type ReportCategoriesUpdateData = {
  body: UpdateReportCategoryDto;
  path: {
    reportCategoryId: string;
  };
  query?: never;
  url: '/api/report-categories/{reportCategoryId}';
};

export type ReportCategoriesUpdateResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type ReportCategoriesUpdateResponse = ReportCategoriesUpdateResponses[keyof ReportCategoriesUpdateResponses];

export type AdminLevelsFindAllData = {
  body?: never;
  path?: never;
  query?: {
    type?: Array<AdminLevelType>;
    active?: boolean;
  };
  url: '/api/admin-levels';
};

export type AdminLevelsFindAllResponses = {
  200: Array<AdminLevel>;
};

export type AdminLevelsFindAllResponse = AdminLevelsFindAllResponses[keyof AdminLevelsFindAllResponses];

export type AdminLevelsFindOneData = {
  body?: never;
  path: {
    adminLevelId: string;
  };
  query?: {
    parents?: boolean;
    children?: boolean;
    users?: boolean;
  };
  url: '/api/admin-levels/{adminLevelId}';
};

export type AdminLevelsFindOneResponses = {
  200: AdminLevel;
};

export type AdminLevelsFindOneResponse = AdminLevelsFindOneResponses[keyof AdminLevelsFindOneResponses];

export type AdminLevelsUpdateData = {
  body: UpdateAdminLevelDto;
  path: {
    adminLevelId: string;
  };
  query?: never;
  url: '/api/admin-levels/{adminLevelId}';
};

export type AdminLevelsUpdateResponses = {
  200: AdminLevel;
};

export type AdminLevelsUpdateResponse = AdminLevelsUpdateResponses[keyof AdminLevelsUpdateResponses];

export type AdminLevelsRemoveAdminLevelUserData = {
  body?: never;
  path: {
    adminLevelId: string;
    userId: string;
  };
  query?: never;
  url: '/api/admin-levels/{adminLevelId}/users/{userId}';
};

export type AdminLevelsRemoveAdminLevelUserResponses = {
  200: AdminLevelUser;
};

export type AdminLevelsRemoveAdminLevelUserResponse =
  AdminLevelsRemoveAdminLevelUserResponses[keyof AdminLevelsRemoveAdminLevelUserResponses];

export type AdminLevelsFindOneAdminLevelUserData = {
  body?: never;
  path: {
    adminLevelId: string;
    userId: string;
  };
  query?: never;
  url: '/api/admin-levels/{adminLevelId}/users/{userId}';
};

export type AdminLevelsFindOneAdminLevelUserResponses = {
  200: AdminLevelUser;
};

export type AdminLevelsFindOneAdminLevelUserResponse =
  AdminLevelsFindOneAdminLevelUserResponses[keyof AdminLevelsFindOneAdminLevelUserResponses];

export type AdminLevelsUpdateAdminLevelUserData = {
  body: CreateAdminLevelUserDto;
  path: {
    adminLevelId: string;
    userId: string;
  };
  query?: never;
  url: '/api/admin-levels/{adminLevelId}/users/{userId}';
};

export type AdminLevelsUpdateAdminLevelUserResponses = {
  200: AdminLevelUser;
};

export type AdminLevelsUpdateAdminLevelUserResponse =
  AdminLevelsUpdateAdminLevelUserResponses[keyof AdminLevelsUpdateAdminLevelUserResponses];

export type AdminLevelsCreateAdminLevelUserData = {
  body: CreateAdminLevelUserDto;
  path: {
    adminLevelId: string;
    userId: string;
  };
  query?: never;
  url: '/api/admin-levels/{adminLevelId}/users/{userId}';
};

export type AdminLevelsCreateAdminLevelUserResponses = {
  201: AdminLevelUser;
};

export type AdminLevelsCreateAdminLevelUserResponse =
  AdminLevelsCreateAdminLevelUserResponses[keyof AdminLevelsCreateAdminLevelUserResponses];

export type RadvisImportImportBicycleNetworkData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/radvis-import/bicycle-network';
};

export type RadvisImportImportBicycleNetworkResponses = {
  201: boolean;
};

export type RadvisImportImportBicycleNetworkResponse =
  RadvisImportImportBicycleNetworkResponses[keyof RadvisImportImportBicycleNetworkResponses];

export type RadvisImportImportRouteSignsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/radvis-import/route-signs';
};

export type RadvisImportImportRouteSignsResponses = {
  201: boolean;
};

export type RadvisImportImportRouteSignsResponse =
  RadvisImportImportRouteSignsResponses[keyof RadvisImportImportRouteSignsResponses];

export type RadvisImportImportServiceStationsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/radvis-import/service-stations';
};

export type RadvisImportImportServiceStationsResponses = {
  201: boolean;
};

export type RadvisImportImportServiceStationsResponse =
  RadvisImportImportServiceStationsResponses[keyof RadvisImportImportServiceStationsResponses];

export type DashboardAnalyzeData = {
  body: DashboardFilterDto;
  path?: never;
  query?: never;
  url: '/api/dashboard';
};

export type DashboardAnalyzeResponses = {
  201: DashboardResultDto;
};

export type DashboardAnalyzeResponse = DashboardAnalyzeResponses[keyof DashboardAnalyzeResponses];

export type ExternalReportsTestData = {
  body?: never;
  path: {
    adminLevelId: string;
  };
  query?: never;
  url: '/api/external-reports/{adminLevelId}/test';
};

export type ExternalReportsTestResponses = {
  200: string;
};

export type ExternalReportsTestResponse = ExternalReportsTestResponses[keyof ExternalReportsTestResponses];

export type ExternalReportsGetCategoriesData = {
  body?: never;
  path: {
    adminLevelId: string;
  };
  query?: never;
  url: '/api/external-reports/{adminLevelId}/categories';
};

export type ExternalReportsGetCategoriesResponses = {
  200: Array<ExternalReportCategory>;
};

export type ExternalReportsGetCategoriesResponse =
  ExternalReportsGetCategoriesResponses[keyof ExternalReportsGetCategoriesResponses];

export type ExternalReportsCreateData = {
  body: CreateExternalReportDto;
  path: {
    adminLevelId: string;
  };
  query?: never;
  url: '/api/external-reports/{adminLevelId}';
};

export type ExternalReportsCreateErrors = {
  /**
   * ThrottlerException: Too Many Requests.
   */
  429: unknown;
};

export type ExternalReportsCreateResponses = {
  /**
   * The external report has been successfully created.
   */
  201: Report;
};

export type ExternalReportsCreateResponse = ExternalReportsCreateResponses[keyof ExternalReportsCreateResponses];

export type ExternalReportsGetStatusData = {
  body?: never;
  path: {
    adminLevelId: string;
    reportId: string;
  };
  query?: never;
  url: '/api/external-reports/{adminLevelId}/status/{reportId}';
};

export type ExternalReportsGetStatusResponses = {
  200: ExternalReportStatusDto;
};

export type ExternalReportsGetStatusResponse =
  ExternalReportsGetStatusResponses[keyof ExternalReportsGetStatusResponses];

export type SystemNotificationsFindAllData = {
  body?: never;
  path?: never;
  query?: {
    filter?: SystemNotificationFilter;
  };
  url: '/api/system-notifications';
};

export type SystemNotificationsFindAllResponses = {
  200: Array<SystemNotification>;
};

export type SystemNotificationsFindAllResponse =
  SystemNotificationsFindAllResponses[keyof SystemNotificationsFindAllResponses];

export type SystemNotificationsCreateData = {
  body: CreateSystemNotificationDto;
  path?: never;
  query?: never;
  url: '/api/system-notifications';
};

export type SystemNotificationsCreateResponses = {
  201: SystemNotification;
};

export type SystemNotificationsCreateResponse =
  SystemNotificationsCreateResponses[keyof SystemNotificationsCreateResponses];

export type SystemNotificationsRemoveData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/system-notifications/{id}';
};

export type SystemNotificationsRemoveResponses = {
  200: SystemNotification;
};

export type SystemNotificationsRemoveResponse =
  SystemNotificationsRemoveResponses[keyof SystemNotificationsRemoveResponses];

export type SystemNotificationsFindOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/system-notifications/{id}';
};

export type SystemNotificationsFindOneResponses = {
  200: SystemNotification;
};

export type SystemNotificationsFindOneResponse =
  SystemNotificationsFindOneResponses[keyof SystemNotificationsFindOneResponses];

export type SystemNotificationsUpdateData = {
  body: UpdateSystemNotificationDto;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/system-notifications/{id}';
};

export type SystemNotificationsUpdateResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type SystemNotificationsUpdateResponse =
  SystemNotificationsUpdateResponses[keyof SystemNotificationsUpdateResponses];
